


































































import Vue from 'vue'
import {
  SendTelegram,
  TelegramConfig,
  GetTelegramConfig,
  PatchTelegramConfig,
} from '@/api/notif'
export default Vue.extend({
  name: 'Telegram',
  data() {
    return {
      testRunning: false,
      message: 'Hi, this is test message.',
      config: {
        botName: '',
        botToken: '',
        chatName: '',
        chatID: 0,
      } as TelegramConfig,
    }
  },

  methods: {
    async sendMessage() {
      this.testRunning = true
      try {
        await SendTelegram(this.message)
      } catch {
        //
      }
      setTimeout(() => {
        this.testRunning = false
      }, 2000)
    },

    async getConfig() {
      this.config = await GetTelegramConfig()
    },

    async patchConfig() {
      await PatchTelegramConfig(this.config)
    },
  },

  created() {
    this.getConfig()
  },
})
